import * as React from 'react';

export const UserSessionContext = React.createContext<{
  loggedIn: boolean;
}>({ loggedIn: false });

interface UserSessionProviderPropTypes {
  loggedIn: boolean;
}

export const UserSessionProvider: React.FC<UserSessionProviderPropTypes> = ({
  children,
  loggedIn,
}) => {
  return (
    <UserSessionContext.Provider value={{ loggedIn }}>
      {children}
    </UserSessionContext.Provider>
  );
};
